// extracted by mini-css-extract-plugin
export default {"main":"InvalidRoute_main__NXn7H","container":"InvalidRoute_container__pxl0r","title":"InvalidRoute_title__MNU7Q","txt":"InvalidRoute_txt__CXIjC","btn":"InvalidRoute_btn__jk+K1"};